exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-b35b3bbe]{background:#f7f7f7;font-size:.28rem;color:#19191a;width:86%;height:7.506rem;margin-left:3%;padding:0 4%;text-align:center}.container .title[data-v-b35b3bbe]{text-align:center;margin-bottom:.32rem;padding-top:.65rem}.container ul li[data-v-b35b3bbe]:first-child{max-width:30%;text-align:left;float:left;width:1.4rem}.container ul li[data-v-b35b3bbe]:last-child{width:70%;text-align:left;float:left}.container li[data-v-b35b3bbe]{display:inline-block}.container ul[data-v-b35b3bbe]{line-height:.44rem}.container ul[data-v-b35b3bbe]:after{content:\"\";display:block;clear:both}.container .tips[data-v-b35b3bbe]{font-size:.28rem;color:#ff5548}.QRcode[data-v-b35b3bbe]{width:100%;text-align:center}.QRcode p[data-v-b35b3bbe]{font-size:.24rem;color:#19191a;padding-bottom:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b35b3bbe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pass-status/components/SignContract.vue
// module id = Mttl
// module chunks = 1